<script setup>
import { useAccount } from 'dashboard/composables/useAccount';
import { useBranding } from 'shared/composables/useBranding';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import DocumentCard from 'dashboard/components-next/captain/assistant/DocumentCard.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';
import { documentsList } from 'dashboard/components-next/captain/pageComponents/emptyStates/captainEmptyStateContent.js';

const emit = defineEmits(['click']);
const { isOnChatwootCloud } = useAccount();

const { replaceInstallationName } = useBranding();

const onClick = () => {
  emit('click');
};
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <FeatureSpotlight
      :title="$t('CAPTAIN.DOCUMENTS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
      :note="$t('CAPTAIN.DOCUMENTS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
      fallback-thumbnail="/assets/images/dashboard/captain/document-light.svg"
      fallback-thumbnail-dark="/assets/images/dashboard/captain/document-dark.svg"
      learn-more-url="https://chwt.app/captain-document"
      :hide-actions="!isOnChatwootCloud"
      class="!rounded-xl !border !border-solid !border-auth-border !bg-auth-surface dark:!border-auth-border-dark dark:!bg-auth-surface-dark [&_button]:focus-visible:!outline-auth-action dark:[&_button]:focus-visible:!outline-auth-accent"
    />
    <EmptyStateLayout
      :title="$t('CAPTAIN.DOCUMENTS.EMPTY_STATE.TITLE')"
      :subtitle="$t('CAPTAIN.DOCUMENTS.EMPTY_STATE.SUBTITLE')"
      :action-perms="['administrator']"
      :show-backdrop="false"
      class="min-h-80 flex-1 rounded-xl border border-dashed border-auth-border bg-auth-surface px-6 dark:border-auth-border-dark dark:bg-auth-surface-dark [&>div]:!min-h-80 [&>div]:!max-h-none [&>div>div]:!justify-center [&>div>div]:!pb-0 [&_.mt-48]:!mt-0"
    >
      <template #empty-state-item>
        <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
          <DocumentCard
            v-for="(document, index) in documentsList.slice(0, 5)"
            :id="document.id"
            :key="`document-${index}`"
            :name="replaceInstallationName(document.name)"
            :assistant="document.assistant"
            :external-link="document.external_link"
            :created-at="document.created_at"
          />
        </div>
      </template>
      <template #actions>
        <Button
          :label="$t('CAPTAIN.DOCUMENTS.ADD_NEW')"
          icon="i-lucide-plus"
          class="!bg-auth-action !text-white hover:!bg-auth-action-hover focus-visible:!outline-auth-action dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover dark:focus-visible:!outline-auth-accent"
          @click="onClick"
        />
      </template>
    </EmptyStateLayout>
  </div>
</template>
